<template>
  <a
    class="gw_linkguide"
    target="_blank"
    :href="link"
  >
    <span class="mdi gw_linkguide_icon mdi-book-information-variant mr-1"></span>
    <span
      v-if="text"
      class="text-underline hover_lighted"
      v-html="text"
    ></span>
  </a>
</template>

<script>
export default {
  name: 'LinkGuide',
  props: {
    link: { type: String, required: true },
    text: { type: String, required: false },
  },
}
</script>

<style scoped lang="scss">
.gw_linkguide {
  --gwlinkguide-font-size: 0.875rem;
  --gwlinkguide-icon-font-size: 0.875rem;
  --gwlinkguide-font-weight: 500;
  font-size: var(--gwlinkguide-font-size);
  font-weight: var(--gwlinkguide-font-weight);
  &_icon {
    font-size: var(--gwlinkguide-icon-font-size);
  }
}
</style>
